"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const icons_1 = require("../../icons");
const index_1 = require("../index");
const x_date_pickers_1 = require("@mui/x-date-pickers");
const AdapterMoment_1 = require("@mui/x-date-pickers/AdapterMoment");
const react_1 = __importDefault(require("react"));
const CustomPickersDay_1 = require("./CustomPickersDay");
const utils_1 = require("./utils");
const DatePicker = ({ value, variant = 'day', label, onChange, minDate, maxDate, error, helperText, fullWidth, showYear, disabled = false, rounded = false, shouldDisableDate, }) => {
    const handleBackwardClick = () => {
        const newVal = (0, utils_1.getSubtractedDateValue)({ value, variant });
        onChange(newVal);
    };
    const handleForwardClick = () => {
        const newVal = (0, utils_1.getAddedDateValue)({ value, variant });
        onChange(newVal);
    };
    const rangeStart = variant === 'default' ? null : value.clone().startOf(variant);
    const rangeEnd = variant === 'default' ? null : value.clone().endOf(variant);
    const renderWeekPickerDay = (pickersDayProps) => {
        return (react_1.default.createElement(CustomPickersDay_1.CustomPickersDay, { ...pickersDayProps, disableMargin: true, variant: variant, date: pickersDayProps.day, value: value }));
    };
    return (react_1.default.createElement(x_date_pickers_1.LocalizationProvider, { dateAdapter: AdapterMoment_1.AdapterMoment }, variant === 'default' ? (react_1.default.createElement(index_1.Box, { sx: {
            '& .MuiOutlinedInput-root': {
                cursor: 'pointer',
            },
            '& .MuiOutlinedInput-root input': {
                cursor: 'text',
            },
        } },
        react_1.default.createElement(x_date_pickers_1.MobileDatePicker, { value: value, label: label, disabled: disabled, onChange: onChange, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, slotProps: {
                textField: {
                    error: error,
                    helperText: helperText,
                    fullWidth: fullWidth,
                    InputProps: { endAdornment: react_1.default.createElement(icons_1.Calendar, { color: "action" }) },
                },
            }, componentsProps: {
                toolbar: {
                    hidden: true,
                },
                dialog: {
                    sx: {
                        '& .MuiPickersDay-today': {
                            backgroundColor: 'grey.300',
                            borderRadius: '50%',
                            '&:not(.Mui-selected)': {
                                border: 'none !important',
                            },
                        },
                        '& .MuiDialogActions-root button': {
                            display: 'none', //hide buttons
                        },
                        '& .PrivatePickersSlideTransition-root': {
                            minHeight: '235px',
                        },
                    },
                },
            } }))) : (react_1.default.createElement(index_1.Box, { display: "flex", sx: {
            ...(rounded ? { height: '36px' } : {}),
            border: rounded ? 'none' : 'solid 1px',
            borderColor: 'grey.200',
            borderRadius: '8px',
            width: 'fit-content',
            '& .MuiOutlinedInput-root': {
                borderRadius: '0px',
            },
            '& .MuiOutlinedInput-root fieldset': {
                border: 'none',
            },
            '& .MuiOutlinedInput-root:hover fieldset': {
                border: 'none',
            },
            '& input': {
                cursor: 'pointer',
                padding: '10px 12px',
                textAlign: 'center',
                fontSize: 'body2.fontSize',
                color: 'text.primary', //theme.palette.text.primary
                // ...theme.typography.body2, //@TODO
            },
            '& input:hover, & input:focus, & button:hover': {
                backgroundColor: 'primary.light',
                color: 'primary.main', //theme.palette.primary.main
            },
            '& input.Mui-disabled': {
                color: 'text.primary',
                textFillColor: 'inherit', //theme.palette.text.primary
            },
            '& input.Mui-disabled:hover, & input.Mui-disabled:focus': {
                backgroundColor: 'inherit',
                cursor: 'inherit',
            },
            '& button': {
                padding: '9px',
                borderRight: 'solid 1px',
                borderLeft: 'solid 1px',
                borderColor: 'grey.200',
                borderRightColor: 'grey.200', //theme.palette.grey[200] //some reason bordercolor isn't effecting right
            },
        } },
        react_1.default.createElement(index_1.IconButton, { "data-testid": "date-picker-backward", sx: rounded
                ? {
                    borderRadius: '500px 0 0 500px',
                    border: '1px solid',
                    borderColor: 'grey.200',
                    '& .svg-inline--fa': {
                        height: '14px',
                        width: '14px',
                    },
                }
                : {
                    borderRadius: '8px 0 0 8px',
                    borderLeft: 'none!important',
                }, onClick: handleBackwardClick, disabled: disabled || (minDate && minDate.isSameOrAfter(value) && minDate.isBefore(rangeEnd)) }, rounded ? react_1.default.createElement(icons_1.ChevronLeftRegular, { height: "14px", width: "14px" }) : react_1.default.createElement(icons_1.ChevronLeft, null)),
        react_1.default.createElement(x_date_pickers_1.MobileDatePicker, { "data-testid": "date-picker", disabled: disabled || variant === 'month', value: value, onChange: onChange, maxDate: maxDate, minDate: minDate, shouldDisableDate: shouldDisableDate, slots: {
                day: renderWeekPickerDay,
            }, slotProps: {
                textField: {
                    error: error,
                    helperText: helperText,
                    fullWidth: fullWidth,
                    //@ts-ignore
                    'data-testid': 'date-picker-input',
                    sx: {
                        '& input': {
                            height: rounded ? '34px' : 'auto',
                            boxSizing: rounded ? 'border-box' : undefined,
                            fontWeight: rounded ? '600' : undefined,
                        },
                        borderTop: rounded ? '1px solid' : undefined,
                        borderBottom: rounded ? '1px solid' : undefined,
                        borderColor: rounded ? 'grey.200' : undefined,
                    },
                },
            }, format: {
                day: 'ddd, MMMM Do',
                week: rangeStart && rangeEnd ? (0, utils_1.weekDateFormat)({ rangeStart, rangeEnd, value }) : '',
                month: showYear ? 'MMMM YYYY' : 'MMMM',
            }[variant], closeOnSelect: variant === 'week', componentsProps: {
                toolbar: {
                    hidden: true,
                },
                dialog: {
                    sx: {
                        '& .MuiDialogActions-root': {
                            display: 'none', // hide bottom bar
                        },
                    },
                },
            } }),
        react_1.default.createElement(index_1.IconButton, { "data-testid": "date-picker-forward", sx: rounded
                ? {
                    borderRadius: '0 500px 500px 0',
                    border: '1px solid',
                    borderColor: 'grey.200',
                    '& .svg-inline--fa': {
                        height: '14px',
                        width: '14px',
                    },
                }
                : {
                    borderRadius: '0 8px 8px 0',
                    borderRight: 'none!important',
                }, onClick: handleForwardClick, disabled: disabled }, rounded ? react_1.default.createElement(icons_1.ChevronRightRegular, { height: "14px", width: "14px" }) : react_1.default.createElement(icons_1.ChevronRight, null))))));
};
exports.default = DatePicker;
